<template>
    <div class="doctors">
        <div class="list" v-if="list && list.length">
            <div class="item" v-for="(item, index) in list" :key="item.id">
                <div class="avatar">
                    <van-image
                        fit="cover"
                        :src="item.photo"
                    />
                </div>
                <div class="con">
                    <div class="name">
                        <span class="n">
                            {{item.name}}
                            <span class="p">
                                {{ getDictOptionsLabel(resourceTitlesComputed, item.clinicalTitle?Number(item.clinicalTitle):item.clinicalTitle, 'key', 'value')}}
                            </span>
                        </span>
                        <van-button size="mini" type="primary" class="copy" @click="openDialog(item)">复制二维码</van-button>
                        
                    </div>
                    <div class="des">
                        {{item.goodAt || "-"}}
                    </div>
                    <div class="service">
                        <div class="tag" v-for="i in askMethodTypes" :key="i.value">{{i.label}} 
                            ￥{{item[i.prop] || 0}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-empty description="暂无数据" v-else />

        <div class="code-box" ref="CodeRef">
            <div class="h">
                润生医荃宜互联网医院
            </div>
            <div class="n">
                【{{active.name}}】医生专属预约码
            </div>
            <img :src="active.codeUrl" />
            <div class="h">
                微信扫码或者长按识别
            </div>
        </div>
        <van-dialog v-model:show="codeDialog.show" title="" show-cancel-button :showConfirmButton="false" cancelButtonText="关闭">
            <van-image :src="codeDialog.img"></van-image>
        </van-dialog>
    </div>
</template>
<script>
import request from "@/utils/request";
import qrcode from 'qrcode'
import { getDictOptionsLabel } from "@/utils/function";
import { AskMethodType } from '@/hooks/useAsk/type'
import { fileBase64ToFile } from '@/hooks/file'
import Html2canvas from 'html2canvas'

// 专属医生的问诊方式
const askMethodTypes = [
  {
    label: "视频问诊",
    value: AskMethodType.VIDEO,
    prop:"audioAskPrice"
  },
  {
    label: "图文问诊",
    value: AskMethodType.PHONE,
    prop:"phoneAskPrice"
  },
];
export default {
    name: 'ReservationDoctors',
    components: {

    },
    props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        },
        list: {
            type: Array
        },
    },
    watch: {
        currentPage(val) {
            this.pageNum = val
        }
    },
    data() {
        return {
            askMethodTypes,
            pageNum: 1,
            active:{},
            codeDialog:{
                img:"",
                show:false
            },
            resourceTitles:[]
        }
    },
    computed: {
        resourceTitlesComputed() {
            return this.resourceTitles;
        },
    },
    async mounted() {
        await this.configResourceTitleGet()
    },
    methods: {
        getDictOptionsLabel,
        pageChange(val) {
            this.$emit('pageChange', val)
        },

        //职称获取
        configResourceTitleGet(){
            request({
                method: 'get',
                url: '/misc-service/typeInfo/detail',
                params: {
                    typeCode: 'TITLE_TYPE'
                }
            }).then(({ data, code }) => {
                if (code === 0) {
                    this.resourceTitles = data.list || []
                } 
            }).catch(() => {
                
            })
        },
        openDialog(item){
            this.active = item
            let that = this
            try {
                var opts = {
                    errorCorrectionLevel: 'H',
                    type: 'image/jpeg',
                    quality: 0.3,
                    margin: 1,
                    color: {
                        light: "#fff"
                    }
                }
                let url = `${process.env.VUE_APP_MINI_LOCTION_HOST}?doctorNo=${this.active.doctorNo}`
                qrcode.toDataURL(url, opts, async (err, base64Url) => {
                    if (err) throw err;
                    that.active.codeUrl = base64Url;
                    this.$nextTick(async () => {
                        this.onCopyImg()
                    });
                });
            } catch (error) {
                console.log(error)
            }
        },
        async onCopyImg() {
            const base64 = await this.onCanvasCreate()
            try {
                const file = await fileBase64ToFile(base64, `${this.active.name}医生专属预约码`)
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [file.type]: file,
                    }),
                ]);
                this.$toast.success("复制成功");
            } catch (error) {
                this.$toast('请长按图片进行分享')
                this.codeDialog.img = base64
                this.codeDialog.show = true
            }
        },
        async onCanvasCreate() {
            const canvas = await Html2canvas(this.$refs.CodeRef, {
                scale: 2
            })
            return canvas.toDataURL('image/png')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";
.doctors {
    .list{
        padding: 0 10px;
        background-color: #fff;
        .item{
            @include flex();
            font-size: 14px;
            border-bottom: 1px solid #E1E8EF;
            padding: 10px 0;
            &:last-child{
                border: none;
            }
            .avatar{
                width: 60px;
                #{$deep} .van-image{
                    width: 50px;
                    height: 50px;
                    >img{
                        border-radius: 4px;
                    }
                }
            }
            .con{
                flex: 1;
                .name{
                    @include flex();
                    .n{
                        font-size: 18px;
                        font-weight: bold;
                        margin-right: 6px;
                        flex: 1;
                        .p{
                            margin-left: 6px;
                            font-size: 14px;
                            font-weight: normal;
                        }
                    }
                }
                .des{
                    @include text-overflow-line(2);
                    margin-top: 8px;
                }
                .service{
                    @include flex();
                    margin-top: 10px;
                    >span{
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .pagination {
        padding: 20px 0;
    }
}
.code-box{
    text-align: center;
    padding: 20px;
    position: absolute;
    left: -100%;
    top: -1000px;
    >div{
        margin-bottom: 20px;
        &:first-child{
            padding-top: 30px;
        }
    }
    >img{
        width: 200px;
        margin: 10px 0;
    }
    .h{
        font-size: 16px;
    }
    .n{
        font-size: 18px;
        font-weight: bold;
        color: #0082EF;
    }
}
.copy {
    color: #0082EF;
    background: #D6E9FE;
    border: none;
    padding: 6px 14px;
    font-size: 14px;
}
.tag {
    padding: 6px 14px;
    background-color: #f5f5f5;
    margin-right: 10px;
    border-radius: 4px;
    font-size: 14px;
}
</style>